import { COLORS } from "../../common/constants";

const styles = {
  logo: { width: "200px", cursor: "pointer" },
  profileContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
  },
  name: {
    font: "normal normal 500 16px/30px mreavesxlsanot-reg",
    textTransform: "capitalize",
    marginRight: "14px",
  },
  avtar: {
    width: "40px",
    height: "40px",
    border: "1.5px solid #E5063E80",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "14px",
    img: {
      width: "36px",
      height: "36px",
      borderRadius: "50%",
    },
    "&.bordernone": {
      border: "none",
    },
  },
  notification: {
    cursor: "pointer",
  },
  wrap: { display: "flex", gap: "40px", alignItems: "center" },
  role: { font: "normal normal 400 14px/18px MrEavesXLSanOT" },
  actionTitle: {
    font: "normal normal 400 16px/23px MrEavesXLSanOT",
    padding: "20px 30px",
    color: COLORS.black,
    cursor: "pointer",
  },
  actionContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "10px 15px",
    borderRadius: "12px",
    border: "1px solid #E0E2E7",
    boxShadow: "0px 4px 44px 0px #00000014",
  },
  divider: { width: "100%", backgroundColor: COLORS.hrbg, margin: "0 auto" },
  popOver: {
    "& .MuiPopover-paper": {
      width: "300px",
      borderRadius: "12px",
      top: "70px !important",
      right: "30px",
      left: "unset !important",
      boxShadow: `0px 21px 33px rgb(219 219 219 / 25%)`,
    },
  },
  arrow: { fontSize: "30px", color: "#8E8E93" },
  profileBg: {
    height: "40px",
    width: "40px",
    backgroundColor: COLORS.grayButtonColor,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    marginRight: "12px",
  },
  initials: { font: "normal normal 700 18px/22px MrEavesXLSanOT" },
  profileImg: {
    borderRadius: "50%",
    height: "40px",
    width: "40px",
    marginRight: "12px",
  },
};
export default styles;
